import { render, staticRenderFns } from "./JbPicture.vue?vue&type=template&id=74bc97f6"
import script from "./JbPicture.vue?vue&type=script&lang=js"
export * from "./JbPicture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports